import { useState } from 'react';
import toast from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { yupResolver } from '@hookform/resolvers/yup';

import passwordSchema from 'schemas/passwordSchema';
import updatePassword from 'api/user/updatePassword';

interface FormValues {
  password: string;
  newPassword: string;
  passwordConfirm: string;
}

const usePassword = () => {
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const useFormReturn = useForm<FormValues>({
    defaultValues: {
      password: '',
      newPassword: '',
      passwordConfirm: '',
    },
    resolver: yupResolver(passwordSchema),
  });

  const updateMutation = useMutation({
    mutationFn: updatePassword,
    onSuccess: () => {
      useFormReturn.reset();
      setIsUpdateMode(false);
      toast.success('비밀번호가 변경되었습니다.');
    },
    onError: (error: any) => {
      if (error?.message === '11009') {
        return useFormReturn.setError('password', { message: '비밀번호가 일치하지 않습니다.' });
      }
      toast.error('저장에 실패했습니다.');
    },
  });

  const isDisabled = !useFormReturn.watch('newPassword') && !useFormReturn.watch('passwordConfirm');

  const onValid = ({ password, newPassword }: FormValues) => {
    updateMutation.mutate({ password, newPassword });
  };

  const handleUpdateModeButtonClick = () => {
    setIsUpdateMode(true);
  };

  return {
    isUpdateMode,
    useFormReturn,
    isDisabled,
    onValid,
    onUpdateModeButtonClick: handleUpdateModeButtonClick,
  };
};

export default usePassword;
